export default "__VITE_ASSET__ce8bc8e6__"